import { AlertType, GradeProduto, KEY_CODE_ENTER, KEY_CODE_ESCAPE, RetAPI, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import React, { FC, useEffect, useRef, useState } from 'react'
import { ProdutoService } from '../../Pages/Products/ProdutoService'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { MdGridOn } from 'react-icons/md'

type Props = {
    visible: boolean
    loading: boolean
    idProd: number
    LancamentoEfetuadoAcertoEstoqueClick?: () => void
    LancamentoEfetuadoItemNFClick?: (grade: GradeProduto[]) => void
    closeModalEvent: () => void
}

export const ModalLancaGradeProdutos = React.memo(({ visible, loading, idProd, LancamentoEfetuadoAcertoEstoqueClick, LancamentoEfetuadoItemNFClick, closeModalEvent }: Props) => {

    // ---------- ATRIBUTOS FEEDBACK --------------------------------------------------
    const [loadingGrade, setLoadingGrade] = useState(false)
    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS LISTA GRADE -----------------------------------------------
    const [gradeList, setGradeList] = useState<GradeProduto[]>([])

    // ---------- ATRIBUTOS TIPO DE LANÇAMENTO ----------------------------------------
    const [tipo, setTipo] = useState("E")
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {

        if (visible) {

            getFilter()

            let modal = document.getElementById('modal_abrir_grade_venda')
            let modalContent = document.getElementById('modal_content_abrir_grade_venda')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-600px]')
                    modalContent.classList.add('mt-36')
                }
            }

        } else {

            setVisibleMsg(false)
            setGradeList([])
            setTipo('E')

            let modal = document.getElementById('modal_abrir_grade_venda')
            let modalContent = document.getElementById('modal_content_abrir_grade_venda')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-600px]')
                    modalContent.classList.remove('mt-36')
                }
            }
        }

    }, [visible])

    useEffect(() => {
        const handleKeyPressESC = (event: any) => {

            if (event.code === KEY_CODE_ESCAPE && visible && !loading && !loadingGrade) {
                closeModalEvent()
            }

        }

        document.addEventListener('keydown', handleKeyPressESC)

        return () => {
            document.removeEventListener('keydown', handleKeyPressESC)
        }

    }, [visible, loading, loadingGrade])

    const handleInputChange = (id: number, value: string) => {
        const newGradeList = [...gradeList]
        newGradeList[id].valorEntrada = parseInt(value)
        setGradeList(newGradeList)
    }

    const getFilter = async () => {

        setLoadingGrade(true)

        try {
            const attributes = await ProdutoService.GetGradeProduto(idProd.toString())
            setGradeList(attributes)

        } catch (error) {
            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Ocorreu um erro ao retornar as grades do produto`)

        } finally {
            setLoadingGrade(false)
            inputfocus()
        }
    }

    const handleTipoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipo(e.target.value)
    }

    const inputfocus = () => {
        const inputElement = document.getElementById("inputVariacaoGrade")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    const handleLancarGrade = async () => {

        setVisibleMsg(false)

        if (tipo === "") {
            setMessageType("DANGER")
            setMessage("Favor selecionar o tipo do lançamento")
            setVisibleMsg(true)
            return
        }

        const grades: any[] = []
        gradeList.map((item) => {
            if (item.valorEntrada && item.valorEntrada > 0) {
                grades.push(
                    {
                        id: item.id,
                        estoque: item.valorEntrada
                    }
                )
            }

        })

        if (grades.length > 0) {

            if (LancamentoEfetuadoAcertoEstoqueClick) {

                setLoadingGrade(true)
                const retApi: RetAPI = await ProdutoService.LancarGrade(tipo, JSON.stringify(grades))
                setLoadingGrade(false)

                if (retApi.error === true) {

                    setMessageType("DANGER")
                    setMessage(retApi.msg || "")
                    setVisibleMsg(true)

                } else {

                    setMessageType("SUCCESS")
                    setMessage("Lançamento efetuado com sucesso")
                    setVisibleMsg(true)

                    const intervalo = setInterval(() => {

                        clearInterval(intervalo)
                        if (LancamentoEfetuadoAcertoEstoqueClick) {
                            LancamentoEfetuadoAcertoEstoqueClick()
                        }

                    }, 1500)
                }

            } else {

                if (LancamentoEfetuadoItemNFClick) {
                    let newGradeList = [...gradeList]
                    newGradeList = gradeList.filter(item => item.valorEntrada ? item.valorEntrada > 0 : false)
                    LancamentoEfetuadoItemNFClick(newGradeList)
                }
            }

        } else {

            const timer = setTimeout(() => {
                setMessageType("DANGER")
                setMessage("Nenhuma grade selecionada")
                setVisibleMsg(true)
                clearTimeout(timer)
            }, 250)
        }

    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Tab') {
            event.preventDefault(); // evita o comportamento padrão do Tab

            const currentInput = event.currentTarget;
            const inputs = containerRef.current?.querySelectorAll('input');

            if (inputs) {
                const inputsArray = Array.from(inputs);
                const currentIndex = inputsArray.indexOf(currentInput);

                const nextInput = inputsArray[currentIndex + 1];
                if (nextInput) {
                    nextInput.focus();
                }
            }
        }
    }

    return (

        <div ref={containerRef} id="modal_abrir_grade_venda" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_abrir_grade_venda" className={`relative flex flex-col w-[90%] xl:w-[70%] 2xl:w-[60%] h-[550px] bg-white dark:bg-slate-600 rounded-lg transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <MdGridOn size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Grade</span>
                </div>

                <div className={`absolute top-[70px] w-full h-auto px-3 py-4`}>

                    {!LancamentoEfetuadoItemNFClick &&
                        <div className={`relative w-full`}>
                            <select className={`${classInput} ${classInputDark} h-[48px] text-[18px]`} value={tipo} onChange={handleTipoChange}>
                                <option value="E">Entrada</option>
                                <option value="S">Saída</option>
                            </select>
                            <label htmlFor="inputVariacaoGrade" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Tipo do lançamento</label>
                        </div>
                    }

                    <div className={`relative w-full h-auto mt-2`}>

                        <div className={`w-full ${gradeList.length > 6 ? `pr-[11px]` : ``}`}>

                            <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>

                                <li className={`h-full border-2 border-white dark:border-slate-600`}>

                                    <div className={`w-full flex flex-row h-8 font-mono`}>

                                        <div className={`flex items-center w-[30%] h-full border border-slate-300 dark:border-slate-700`}>
                                            <span className={`px-2`}>Variação</span>
                                        </div>

                                        <div className={`flex items-center w-[20%] h-full border border-slate-300 dark:border-slate-700`}>
                                            <span className={`px-2`}>SubVariação</span>
                                        </div>

                                        <div className={`flex items-center w-[20%] h-full border border-slate-300 dark:border-slate-700`}>
                                            <span className={`px-2`}>Código de Barras</span>
                                        </div>

                                        <div className={`flex items-center justify-end w-[15%] h-full border border-slate-300 dark:border-slate-700`}>
                                            <span className={`px-2`}>Estoque</span>
                                        </div>

                                        <div className={`flex items-center justify-center w-[15%] h-full border border-slate-300 dark:border-slate-700`}>
                                            <span className={`px-2`}>{tipo === "E" ? "Entrada" : "Saída"}</span>
                                        </div>

                                    </div>
                                </li>
                            </ul>

                        </div>

                        <div className={`h-[300px] overflow-y-auto scrollbar-track-transparent scrollbar-thumb-slate-400 dark:scrollbar-thumb-slate-800 scrollbar-thin dark:scrollbar-thin`}>

                            <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                <ul id='elementos' className={`w-full h-auto`}>

                                    {gradeList.length > 0 &&
                                        gradeList.map((item, index) => {
                                            return (

                                                <li key={item.id} id={`produto-grade-${index}`}
                                                    className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border-2 border-white dark:border-slate-600 cursor-pointer`}>

                                                    <div className={`w-full flex flex-row h-auto font-mono`}>

                                                        <div className={`flex items-center w-[30%] py-2 break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.variacao.description}</span>
                                                        </div>

                                                        <div className={`flex items-center w-[20%] py-2 break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.subVariacao?.description}</span>
                                                        </div>

                                                        <div className={`flex items-center w-[20%] py-2 break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.codBarraRef}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-end py-2 w-[15%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.saldoEstoque}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-center py-2 w-[15%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <input className='w-3/4 px-2 py-2 text-center bg-transparent border border-gray-800 rounded-md outline-none'
                                                                onChange={(e) => handleInputChange(index || 0, e.target.value.replace(/[^0-9]/g, ''))} onKeyDown={handleKeyDown} />
                                                        </div>

                                                    </div>

                                                </li>
                                            )
                                        })
                                    }

                                </ul>

                            </div>

                        </div>

                    </div>

                </div>

                {loadingGrade &&
                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-white dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={closeModalEvent}
                        className={`${classbtColunasVermelho} max-w-[150px]`}>
                        CANCELAR
                    </button>

                    <button
                        onClick={handleLancarGrade} disabled={loadingGrade}
                        className={`${classbtAzul} ${classBt} max-w-[150px] mx-1`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `LANÇAR` : "AGUARDE"}
                    </button>

                </div>

            </div>

        </div>

    )
})